import React, { useState, useEffect } from 'react'
import { Avatar } from 'antd'
import { UserOutlined } from '@ant-design/icons';

import { 
  useUser, 
  useGame,
  useAvatar 
} from 'data/hooks'

export const Item = (props) => {

  const { gameId, userName, value, position, formatValue } = props
  const { avatar } = useAvatar(gameId, props.userId)
  const { userId } = useUser()

  return (<>
    <div className={`item ${userId === props.userId ? 'me' : ''}`}>
      <div className="position">{position}</div>
      <div className={`
        avatar 
        ${ props.userId }
        ${ props.userData.groupId }
      }`}>
        <Avatar 
          src={avatar} 
          icon={<UserOutlined />} 
        />
      </div>
      <div className="user-name">{userName}</div>
      {
        props.itemdata ?
        props.itemdata
        :
        <div className="value">{formatValue(value)}</div>
      }
    </div>
  </>)
}
